import { useState, useEffect } from "react";

/* ── Inline SVG icons (replaces lucide-react) ── */
const CameraIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
    viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

const HeartIcon = ({ size = 16, filled = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round"
    className="md-icon-heart md-animate-shimmer"
    style={{ color: "var(--md-blossom-deep)" }}>
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const PhotoFrame = ({
  caption,
  rotate = "0deg",
  delay = 0,
  date = "someday, somewhere",
  story = "Write the memory behind this photo here — what we were doing, what you said, why it still makes us smile.",
  imageSrc,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <figure
        onClick={() => setOpen(true)}
        className="md-photo-frame md-animate-fade-in-up"
        style={{ transform: `rotate(${rotate})`, animationDelay: `${delay}ms` }}
      >
        <div className="md-photo-frame__inner">
          {imageSrc ? (
            <img src={imageSrc} alt={caption} />
          ) : (
            <div className="md-photo-frame__placeholder">
              <CameraIcon />
              <span>Add photo</span>
            </div>
          )}
        </div>
        <figcaption className="md-photo-frame__caption">{caption}</figcaption>
      </figure>

      {open && (
        <div className="md-modal-backdrop" onClick={() => setOpen(false)}>
          <div className="md-modal" onClick={e => e.stopPropagation()}>
            <button className="md-modal__close" onClick={() => setOpen(false)}
              aria-label="Close">✕</button>

            <div className="md-modal__photo">
              {imageSrc ? (
                <img src={imageSrc} alt={caption} />
              ) : (
                <div className="md-modal__photo-placeholder">
                  <CameraIcon />
                  <span style={{ fontSize: ".75rem", textTransform: "uppercase", letterSpacing: ".1em" }}>
                    Add photo
                  </span>
                </div>
              )}
            </div>

            <div className="md-modal__body">
              <p className="md-modal__date">{date}</p>
              <h3 className="md-modal__title">{caption}</h3>

              <div className="md-modal__divider">
                <span className="md-modal__divider-line" />
                <HeartIcon size={16} filled />
                <span className="md-modal__divider-line" />
              </div>

              <p className="md-modal__story">{story}</p>

              <p className="md-modal__sign">— with love</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PhotoFrame;
